export const FIRST_NAME_ERROR = 'Please enter a first name'
export const LAST_NAME_ERROR = 'Please enter a last name'
